export default __webpack_public_path__ + "static/media/Corpay x Alpha LockUp_German - Corporate - Vertical - White.70ca2af1.svg";